var _stop, _stop2, _stop3, _stop4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgRefineResults = function SvgRefineResults(props) {
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id, ")"),
    fillRule: "evenodd",
    d: "M2.75 8.417a.92.92 0 0 0 .917.916h14.666a.92.92 0 0 0 .917-.916.92.92 0 0 0-.917-.917H3.667a.92.92 0 0 0-.917.917ZM10.084 18.5h1.833a.92.92 0 0 0 .917-.917.92.92 0 0 0-.917-.916h-1.833a.92.92 0 0 0-.917.916.92.92 0 0 0 .917.917Zm5.5-4.583H6.416A.92.92 0 0 1 5.5 13a.92.92 0 0 1 .917-.917h9.166A.92.92 0 0 1 16.5 13a.92.92 0 0 1-.917.917Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 7,
    r: 6,
    fill: "url(#".concat(_id2, ")"),
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 2.75,
    x2: 19.25,
    y1: 13,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 13,
    x2: 27,
    y1: 7,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  })))));
};
export default SvgRefineResults;